<template>
  <base-dialog v-model="visible" :is-security="true" header="安全信息声明" @done="emits('done')">
    <template #content>
      <p class="leading-[28px]">
        信息安全声明：本课程为腾讯互动娱乐事业群服务采购部的供应商专项合规课程，仅供贵司学习使用，请勿截图、录屏或以任何方式对外传播课程内容，如造成泄密的，我方将根据贵司与我方签署的合同进行追责和处理。
      </p>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { reportEvent, ReportEventName } from '@/utils/galileo';

import BaseDialog from './baseDialog.vue';

const emits = defineEmits(['done']);
const visible = defineModel<boolean>();

watch(visible, () => {
  if (visible.value) {
    reportEvent(ReportEventName.SecurityPv);
  }
});
</script>
